<template>
  <section style="position: relative">
    <ul style="margin: 0; padding: 0">
      <li style="list-style-type: none">
        <el-button plain type="primary" size="mini" @click.prevent="onAddFallback">
          Add Fallback
        </el-button>
      </li>
      <li
        v-for="(fallbackSet, index) in activeFlow.fallbacks"
        :key="index"
        style="list-style-type: none"
      >
        <el-input
          size="mini"
          v-model="fallbackSet.keywords"
          class="keywords input"
          type="text"
          placeholder="eg. keyword1, keyword2"
        />
        <el-select size="mini" v-model="fallbackSet.goto" class="goto input">
          <el-option
            v-for="(option, key) in contentNodes"
            :key="key"
            :label="option.label"
            :value="option.value"
          />
        </el-select>

        <el-button
          type="text"
          id="remove-button"
          class="el-icon-delete"
          style="margin-left: 5px"
          size="mini"
          @click="removeFallbackKeywords(index)"
        />
      </li>
    </ul>
  </section>
</template>

<script>
/**
 * FallbackKeywords - Editor for flow-level keyword-to-content mappings.
 *
 * @component
 * @description Allows configuration of fallback keyword triggers that redirect users to specific
 * content nodes. Each fallback entry maps a comma-separated list of keywords to a target content
 * node. Useful for handling common help requests or topic redirects within a flow.
 *
 * @prop {Object} activeFlow - Flow being configured
 * @prop {Array} activeFlow.fallbacks - Array of {keywords, goto} objects
 *
 * @fires removeFallbackKeywords - Emitted when a fallback entry is removed
 *
 * @example
 * <FallbackKeywords
 *   :active-flow="flow"
 *   @removeFallbackKeywords="handleRemove"
 * />
 */
import _ from "lodash";

export default {
  props: ["activeFlow"],
  computed: {
    contentNodes() {
      const existingContentNodes = this.$store.state.nodes.content;
      const validContentNodes = [];
      Object.keys(existingContentNodes).forEach((key) => {
        if (key && existingContentNodes[key].content.text) {
          validContentNodes.push({ value: key, label: key });
        }
      });

      const sortedValidContentNodes = _.sortBy(validContentNodes, ["value"]);
      return sortedValidContentNodes;
    },
  },
  methods: {
    onAddFallback() {
      const tempFallbackSet = {
        keywords: "",
        goto: "",
      };
      this.activeFlow.fallbacks.push(tempFallbackSet);
    },
    removeFallbackKeywords(index) {
      this.$emit("removeFallbackKeywords", index);
    },
  },
};
</script>

<style>
.keywords.input {
  float: left;
  width: 250px;
}

.goto.input {
  float: left;
  width: 250px;
  padding-left: 5px;
}
</style>
